<mat-toolbar>
  <span><a [routerLink]="['/data/yml']" translate>YMLFILES</a>&nbsp;</span>
  <span> / {{yml && yml.name ? yml.name : 'New YML'}}</span>
  <span class="toolbar-spacer"></span>
  @if (yml && yml.id && !newItem) {
    <button mat-raised-button color="warn" (click)="deleteItem()" translate>DELETE</button>
  }
  <button mat-raised-button color="primary" (click)="saveItem()" class="ms-2">
    <span translate>SAVE</span>
  </button>
</mat-toolbar>

@if (yml) {
  <div class="row my-3">
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>NAME</mat-label>
        <input type="text" matInput [(ngModel)]="yml.name" required>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>DESCRIPTION</mat-label>
        <input type="text" matInput [(ngModel)]="yml.description">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>PRIORITY</mat-label>
        <input type="number" min="0" max="10" step="1" matInput [(ngModel)]="yml.priority">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>TYPE</mat-label>
        <input type="text" matInput [(ngModel)]="yml.type">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>COUNTRY</mat-label>
        <input type="text" matInput [(ngModel)]="yml.country">
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field class="w-100">
        <mat-label translate>FILE</mat-label>
        <textarea rows="10" type="text" matInput [(ngModel)]="yml.file" required></textarea>
      </mat-form-field>
    </div>
  </div>
}
